/* eslint-disable arrow-body-style */
import React from 'react';
import {
    ColumnDef,
} from '@tanstack/react-table';
import UnitMixTable from './UnitMixTable/UnitMixTable';
import GrossRentAdjustmentsTable from './GrossRentAdjustmentsTable/GrossRentAdjustmentsTable';
import OtherIncomeTable from '../commonTables/OtherIncomeTable/OtherIncomeTable';
import TotalPotentialIncomeTable from '../commonTables/TotalPotentialIncomeTable/TotalPotentialIncomeTable';
import IncomeAdjustmentsTable from '../commonTables/IncomeAdjustmentsTable/IncomeAdjustmentsTable';

export interface IApartmentIncomeProps {
    operationBeginIndex: number;
    baseCashFlowColumns: ColumnDef<any>[];
}

const ApartmentIncome = ({
    operationBeginIndex,
    baseCashFlowColumns,
}: IApartmentIncomeProps) => {
    return (
        <>
            <UnitMixTable
                operationBeginIndex={operationBeginIndex}
                baseCashFlowColumns={baseCashFlowColumns}
            />
            <GrossRentAdjustmentsTable
                operationBeginIndex={operationBeginIndex}
                baseCashFlowColumns={baseCashFlowColumns}
            />
            <OtherIncomeTable
                operationBeginIndex={operationBeginIndex}
                baseCashFlowColumns={baseCashFlowColumns}
            />
            <TotalPotentialIncomeTable
                operationBeginIndex={operationBeginIndex}
                baseCashFlowColumns={baseCashFlowColumns}
            />
            <IncomeAdjustmentsTable
                operationBeginIndex={operationBeginIndex}
                baseCashFlowColumns={baseCashFlowColumns}
            />
        </>
    );
};

export default ApartmentIncome;
